// start:ng42.barrel
export * from './confirmation-number.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/confirmation-number/index.ts